import { render } from "./ErrorExpire.vue?vue&type=template&id=472c3118"
import script from "./ErrorExpire.vue?vue&type=script&lang=js"
export * from "./ErrorExpire.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__